import React, {useState} from "react";
import {injectIntl} from "react-intl";
import {useSelector} from "react-redux";
import axios from "axios";
import {headerSortingClasses, sortCaret} from "../../../../_metronic/_helpers";
import {Card, CardBody, CardHeader} from "../../../../_metronic/_partials/controls";
import {PaginationTable} from "../../../components/PaginationTable/PaginationTable";
import {UserActiveColumn, UserInfoColumn} from "../ColumnsFormatter/UserInfoColumn";
import AdminSnackbar from "../AdminSnackbar";
import { fetchTenantUsersPagination } from "../AdminPagesCrud";
import EditOrAddUser from "./EditOrAddUser";

function UserAdminPage(props) {
    const { tenantSuppliers, supplierClients, supplierClientTenantIds, isDataFetched } = props
    const initialValues = {
        fullName: "",
        phoneNumber: "",
        postalAddress: "",
        postalCity: "",
        postalZipcode: "",
        physicalAddress: "",
        physicalCity: "",
        physicalZipcode: "",
        email: "",
        password: "",
        accountType: "",
        active: false,
        emailVerified: false
    };

    const {user,accessToken} = useSelector (
        ({auth}) =>({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    const initialData = {
        data: [],
        totalCount: 0,
        pageSize: 10
    }

    const [data,setData] = useState(initialData)
    const [edit, setEdit] = useState(false)
    const [snackbarUser, setSnackbarUser] = useState(false);
    const [openUserForm, setOpenUserForm] = useState(false)
    const [selectedUser, setSelectedUser] = useState(initialValues)
    const [isLoading, setIsLoading] = useState(false)

    const fetchUsers = (queryParams) => {
        setIsLoading(true)
        queryParams.supplierClientTenantIds = supplierClientTenantIds
        fetchTenantUsersPagination(queryParams, accessToken).then(response => {
            
            const userData = {
                data : response.data.data,
                totalCount : response.data.totalCount,
                pageSize : response.data.pageSize
            }
            setData(userData)
            setIsLoading(false)
        }).catch(error => {
            console.log(error)
            setIsLoading(false)
        })
    }

    const columns = [
        {
            dataField: "fullName",
            text: "Name",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            formatter: UserInfoColumn,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setSelectedUser(row)
                    setOpenUserForm(true)
                }
            },
        },
        {
            dataField: "email",
            text: "Email",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "phoneNumber",
            text: "Mobile Phone",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "accountType",
            text: "Account Type",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "roles",
            text: "Roles",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "active",
            text: "Active",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            formatter: UserActiveColumn
        },
    ];

    const sizePerPageList = [
        { text: "10", value: 10 },
        { text: "20", value: 20 },
        { text: "50", value: 50 }
    ]

    const initialFilter = {
        filter: {
            fullName:"",
            email: "",
            phoneNumber:"",
            accountType: ""
        },
        sortOrder: "asc",
        sortField: "fullName",
        pageNumber: 1,
        pageSize: 10
    }

    const sorting = [{dataField: "fullName",order:"asc"}]
    const pagination = {custom: true, sizePerPageList: sizePerPageList}
    const tableClasses = "table table-head-custom table-head-bg table-borderless table-vertical-center"

    const prepareFilter = (queryParams,values) => {
        const {searchText} = values;
        const newQueryParams = {...queryParams};
        const filter = {};

        filter.fullname = searchText ?? "";
        filter.email = searchText ?? "";
        filter.phoneNumber = searchText ?? "";
        filter.accountType = searchText ?? "";

        newQueryParams.filter = filter;
        return newQueryParams;
    }

    return (
        <>
            {openUserForm ?
                <EditOrAddUser selectedUser={selectedUser} setSelectedUser={setSelectedUser}
                                setShowSnackbar={setSnackbarUser} showSnackbar={snackbarUser}
                                supplierClients={supplierClients} setOpenUserForm={setOpenUserForm}
                                tenantSuppliers={tenantSuppliers}/>
                :
                isDataFetched ? 
                    <Card>
                        <CardHeader title="Registered Users"/>
                        <CardBody>
                            <PaginationTable
                                data={data}
                                columns={columns}
                                pagination={pagination}
                                isLoading={isLoading}
                                sorting={sorting}
                                tableClasses={tableClasses}
                                fetcher={fetchUsers}
                                filterFunction={prepareFilter}
                                initialFilter={initialFilter}/>
                        </CardBody>
                        <AdminSnackbar
                            message={'User information saved successfully'}
                            setShowSnackbar={setSnackbarUser}
                            showSnackbar={snackbarUser}
                            variant={'success'}
                        />
                    </Card>
                : 
                    <div className="row justify-content-center mt-20">
                        <span className="ml-3 spinner spinner-lg spinner-primary"></span>
                    </div>
            
            }
        </>
    );
}

export default injectIntl(UserAdminPage);